import { lsqTriggerSlice } from "components/Ielts/IeltsEliteDemo/redux/IeltsEliteSlice"
import React, { FunctionComponent, useEffect } from "react"
import { useDispatch } from "react-redux"
import { trackEventAsync, trackIeltsClick } from "scripts/segment"
import { EXPERIMENT_SALES_LEAD } from "components/Profile/IeltsProfile/TestPrep/DataMapper"
import useDevice from "hooks/useDevice"
import ThankYouBanner from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/ThankYouBanner"
import Banner from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/Banner"
import BottomButton from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/BottomButton"
import HeaderLogo from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/HeaderLogo"
import { liyABVariant } from "components/Profile/IeltsProfile/TestPrep/LiyThankYouPage2/constant"
import styles from "public/static/scss/IeltsWebsite/PaymentBundle.module.scss"
import { ieltsPageName } from "utils/events-utils"
import { useRouter } from "next/router"
import { navRoutes } from "page_routes"
import { fireTagEvent } from "ga"
import { Button } from "@leap/ui/Buttons"
import Image from "next/image"

interface Props {
  variant: number
}
const LiyThankYouPage2: FunctionComponent<Props> = ({ variant }) => {
  const dispatch = useDispatch()
  const { isMobile } = useDevice()
  const { leadSource } = useRouter().query
  const router = useRouter()

  useEffect(() => {
    dispatch(lsqTriggerSlice(EXPERIMENT_SALES_LEAD))
  }, [])

  useEffect(() => {
    if (variant == liyABVariant.callNow) {
      trackEventAsync("Page Viewed", {
        pageName: "L2E Thank You Page with Call Now",
      })
    } else if (variant == liyABVariant.allCourse) {
      trackEventAsync("Page Viewed", {
        pageName: "L2E Thank You Page with Courses",
      })
    } else if (variant == liyABVariant.menaUser) {
      let flowType = "Onboarding"
      if (
        leadSource === "Web Dashboard" ||
        leadSource === "Reschedule Dashboard" ||
        leadSource === "Async Demo Screen"
      ) {
        flowType = "Dashboard"
      }
      fireTagEvent("Signup_MENA")
      trackEventAsync("Page Viewed", {
        pageName: ieltsPageName.THANQ_PAGE_MENA,
        flowType,
      })
    }
  }, [variant])
  const handleGoToDashboard = async () => {
    await trackEventAsync("Click", {
      contentName: "Go to dashboard",
      pageName: ieltsPageName.THANQ_PAGE_MENA,
    })
    window.open(navRoutes.IELTS_STUDENT_DASHBOARD, "_self")
  }
  return (
    <div
      className={[
        "w-full bg-[#fbfcfe] pt-10 md:pt-14 md-min-w-[1000px] min-h-[800px] md:min-h-screen",
        styles["poppins-font-family"],
      ].join(" ")}
    >
      <HeaderLogo
        onClick={() => {
          if (variant === liyABVariant.menaUser) {
            router.push(navRoutes.IELTS_STUDENT_DASHBOARD)
          }
        }}
      />
      <div className="px-4 pt-8 md:max-w-[800px] mx-auto">
        <ThankYouBanner
          title="Great! You're a step closer to IELTS success."
          totalTime={1500}
        />
        <Banner />
      </div>
      {variant === liyABVariant.menaUser ? (
        <Button
          variant="primary"
          customCss="w-full max-w-[300px] px-4 py-[14px] md:max-w-[221px] rounded-xl flex items-center gap-2 justify-center md:mx-auto mt-6 !fixed md:!static translate-x-[-50%] left-[50%] md:!translate-x-[0]"
          onClick={handleGoToDashboard}
          loadingAnimation={{
            duration: 5,
            onComplete: handleGoToDashboard,
          }}
        >
          <p>Go To Dashboard</p>
          <Image
            src={"/assets/images/conversion-page/right-arrow-white-mobile.svg"}
            height={20}
            width={20}
          />
        </Button>
      ) : (
        <>
          {!isMobile && (
            <div className="md:max-w-[800px] mx-auto relative">
              <div className="w-[50px] rotate-90 border border-dashed border-[#CBCAD5] absolute top-20 left-50 z-0" />
            </div>
          )}
          <BottomButton variant={variant} />
        </>
      )}
    </div>
  )
}

export default LiyThankYouPage2
